namespace $.$$ {

	$mol_style_define( $bog_vmap_app_inspect, {

		flex: { basis: '22rem' },

		Tools: {
			color: $mol_theme.shade,
			font: { size: '.75rem' },
		},

	} )

}
